
function initializeA11y() {
  function modifyIframeWithRemovedSemantics() {
    let frameWithPresentation = Array.from(document.querySelectorAll('iframe[role="presentation"]'));  // IE doesn't support NodeList.forEach, so convert to array

    frameWithPresentation.forEach(function (iframe) {
      iframe.removeAttribute('role');
      iframe.setAttribute('aria-hidden', 'true');
      iframe.setAttribute('title', 'empty');
    });
  }

  setTimeout(function () {

    // Remove `role="presentation"`; add `aria-hidden="true"`; add empty title
    modifyIframeWithRemovedSemantics();

  }, 5000);

  /* events */
  // disable scroll down on spacebar press when a <a> is used like a <button>
  $('.link-button').on('keydown', function (e) {
    if (e.key == ' ') {
      return false;
    }
  });
}



document.addEventListener('DOMContentLoaded', (event) => {
  initializeA11y()
})
